
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription, of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AdminService } from 'src/app/services/admin.service';
import { ConfigService } from 'src/app/services/config.service';
import { DataService } from 'src/app/services/data.service';
import { HomeService } from 'src/app/services/home.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
})
export class FooterComponent {
  // OpenConsent: boolean = true
  libWebsite: string = '';
  Telephone: string;
  EmailContact: string;
  address: string;
  facebook: string;
  AboutUsFooter: string;
  logoSubcription: Subscription = new Subscription();
  pdpaUrl: string = '';
  version: string = '';
  lang: string = 'en';



  constructor(
    private homeService: HomeService,
    private adminService: AdminService,
    private data: DataService,
    private translate: TranslateService,
    private configService: ConfigService
  ) {
    this.version = this.configService.getVersion;
    this.lang = localStorage.getItem('lang') ? localStorage.getItem('lang') : 'en';
    this.AboutUsFooter = '';

    // Subscribe to language changes
    this.translate.onLangChange.subscribe((event) => {
      this.lang = event.lang;
      this.updateAddress();
    });

    this.homeService.getParameter('AboutUsFooter').subscribe((VALUE: any) => {
      if (VALUE.length == 1) {
        this.AboutUsFooter = VALUE[0].VALUE;
      }
    });

    this.Telephone = '';
    this.homeService.getParameter('TelNo').subscribe((VALUE: any) => {
      if (VALUE.length == 1) {
        this.Telephone = VALUE[0].VALUE;
      }
    });

    this.EmailContact = '';
    this.homeService.getParameter('EmailContact').subscribe((VALUE: any) => {
      if (VALUE.length == 1) {
        this.EmailContact = VALUE[0].VALUE;
      }
    });

    this.updateAddress();

    this.facebook = '';
    this.homeService.getParameter('LibraryFacebookURL').subscribe((VALUE: any) => {
      if (VALUE.length == 1) {
        this.facebook = VALUE[0].VALUE;
      }
    });

    this.homeService.getParameter('LibrarySiteURL').subscribe((VALUE: any) => {
      if (VALUE.length == 1) {
        this.libWebsite = VALUE[0].VALUE;
      }
    });

    //PDPA URL
    this.getPDPAUrl();
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    if (this.logoSubcription) {
      this.logoSubcription.unsubscribe();
    }
  }

  updateAddress() {
    this.address = '';
    const paramName = this.lang.toUpperCase() === 'TH' ? 'addressTH' : 'addressEN';
    this.homeService.getParameter(paramName).subscribe((VALUE: any) => {
      if (VALUE && VALUE.length === 1) {
        this.address = VALUE[0].VALUE;
      }
    });
  }


  getPDPAUrl() {

    if (this.configService.siteName === 'MOJ') {
      this.pdpaUrl = 'assets/pdpa_moj.pdf';
      return;
    }


    this.homeService.getParameter('PDPAUrl').subscribe((VALUE: any) => {
      if (VALUE.length == 1) {
        this.pdpaUrl = VALUE[0].VALUE;
        return;
      }
    });


    //  const used =  this.configService.cookieConsent;


  }



  // acceptPDPA(){
  //   this.OpenConsent = false
  //   localStorage.setItem('OpenConsent', 'true')
  // }
}
